import React, { useState } from 'react';

interface DailyReportHeaderProps {
  date: string;
  onPrevDay: () => void;
  onNextDay: () => void;
  onDateChange: (newDate: string) => void;
  isLoading?: boolean;
  hasUnsavedChanges?: boolean;
}

const DailyReportHeader: React.FC<DailyReportHeaderProps> = ({
  date,
  onPrevDay,
  onNextDay,
  onDateChange,
  isLoading = false,
  hasUnsavedChanges = false
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  const handleDateClick = () => {
    if (!showDatePicker) {
      setSelectedDate(date); // 팝업 열 때 현재 날짜로 초기화
    }
    setShowDatePicker(!showDatePicker);
  };
  
  const [selectedDate, setSelectedDate] = useState(date);
  
  const handleDateSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(e.target.value);
  };
  
  const handleDateConfirm = () => {
    onDateChange(selectedDate);
    setShowDatePicker(false);
  };
  
  // 날짜를 한국어 형식으로 포맷팅
  const formatKoreanDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split('-');
    return `${year}년 ${parseInt(month)}월 ${parseInt(day)}일`;
  };
  
  // 요일 계산
  const getDayOfWeek = (dateStr: string) => {
    const date = new Date(dateStr);
    const days = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
    return days[date.getDay()];
  };
  
  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
      <div className="flex items-center justify-between">
        {/* 왼쪽: 제목과 날짜 네비게이션 */}
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-2">
            <h1 className="text-2xl font-bold text-gray-900">데일리 리포트</h1>
            {hasUnsavedChanges && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                저장되지 않음
              </span>
            )}
            {isLoading && (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            )}
          </div>
          
          {/* 날짜 네비게이션 */}
          <div className="flex items-center space-x-2">
                         <button
               onClick={onPrevDay}
               disabled={isLoading}
               className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
               title="이전 날짜"
             >
               <span>◀</span>
             </button>
            
            {/* 날짜 표시 및 선택 */}
            <div className="relative">
              <button
                onClick={handleDateClick}
                disabled={isLoading}
                className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                title="날짜를 클릭하여 달력에서 선택"
              >
                                 <span className="text-gray-500">📅</span>
                <div className="text-left">
                  <div className="font-semibold text-gray-900">{formatKoreanDate(date)}</div>
                  <div className="text-sm text-gray-500">{getDayOfWeek(date)}</div>
                </div>
              </button>
              
              {/* 달력 입력 */}
              {showDatePicker && (
                <div className="absolute top-full left-0 mt-2 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-4">
                  <div className="flex flex-col space-y-3">
                    <input
                      type="date"
                      value={selectedDate}
                      onChange={handleDateSelect}
                      className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      autoFocus
                    />
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={handleDateConfirm}
                        className="px-3 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                      >
                        확인
                      </button>
                      <button
                        onClick={() => setShowDatePicker(false)}
                        className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded transition-colors"
                      >
                        취소
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
                         <button
               onClick={onNextDay}
               disabled={isLoading}
               className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
               title="다음 날짜"
             >
               <span>▶</span>
             </button>
          </div>
        </div>
      </div>
      

    </div>
  );
};

export default DailyReportHeader; 